import { heatRank } from '@/pages/home/data';

const bandColors = [
  { bg: 'bg-accent-500', text: 'text-background-50' },
  { bg: 'bg-foreground-950', text: 'text-primary-200' },
  { bg: 'bg-secondary-500', text: 'text-background-50' },
];

export default function HeatStrip() {
  return (
    <section id="heat" className="scroll-mt bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-accent-600">
              <span className="h-px w-6 bg-accent-500" />
              Hot · 热度榜
            </div>
            <h2 className="mt-3 font-display text-2xl font-bold text-foreground-950 md:text-3xl">
              本周被设计师翻最多
            </h2>
          </div>
          <p className="max-w-md text-sm leading-6 text-foreground-600">
            榜单按单周收藏与浏览折算热度，越靠上越多人直接套用过，做封面海报前先看这里。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {heatRank.map((item, i) => {
            const tone = bandColors[i] ?? bandColors[0];
            return (
              <a
                key={item.rank}
                href="#cover"
                className="group flex cursor-pointer items-center gap-4 rounded-lg border border-background-300/60 bg-background-50 p-4 transition-transform hover:-translate-y-1"
              >
                <span
                  className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-md font-display text-2xl font-black ${tone.bg} ${tone.text}`}
                >
                  {String(item.rank).padStart(2, '0')}
                </span>
                <div className="min-w-0 flex-1">
                  <h3 className="truncate font-display text-base font-bold text-foreground-950 md:text-lg">
                    {item.name}
                  </h3>
                  <p className="mt-1 flex items-center gap-3 text-xs text-foreground-500">
                    <span className="flex items-center gap-1 text-accent-600">
                      <i
                        className={
                          item.trend === 'up'
                            ? 'ri-arrow-up-line'
                            : 'ri-arrow-up-line'
                        }
                      />
                      热度 {item.heat}
                    </span>
                    <span>{item.save}</span>
                  </p>
                  <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                    <div
                      className={`h-full rounded-full ${i === 0 ? 'bg-accent-500' : i === 1 ? 'bg-foreground-950' : 'bg-secondary-500'}`}
                      style={{ width: `${item.heat}%` }}
                    />
                  </div>
                </div>
                <i className="ri-arrow-right-line shrink-0 text-foreground-300 transition-colors group-hover:text-primary-500" />
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}